module.exports = __webpack_public_path__ + "static/media/menuBurger.03a603b1.svg";